import dynamic from 'next/dynamic';
import FirstKv from './components/FirstKv';
import css from './index.module.scss';

const PageConPc = dynamic(() => import('@/componentsH5/Community/indexDynamic'), {
    ssr: true,
});
export default function CommunityPc() {
    return (
        <div className={`community-h5 ${css.CommunityH5}`}>
            <FirstKv />
            <PageConPc />
        </div>
    );
}
